// src/components/directory/ResultsIntro.jsx
// Covers: WZ-03 (wizard carry-through summary) WZ-04 (edit answers)

import React from 'react';
import styles from './ResultsIntro.module.css';

const WHO_LABELS = {
  veteran:'Veterans', caf:'CAF members', rcmp:'RCMP',
  spouse:'Spouses & partners', family:'Family members',
  provider:'Service providers', indigenous:'Indigenous Veterans/families',
  rural:'Rural & remote',
};
const CHAL_LABELS = {
  mental:'Mental health', financial:'Financial', housing:'Housing',
  employment:'Employment', family:'Family', medical:'Medical & rehab',
};

export default function ResultsIntro({ answers, onEdit, visible }) {
  if (!visible) return null;

  const { who = [], challenge = [], province } = answers;
  const tags = [
    ...who.map(w => ({ label: WHO_LABELS[w] || w, type: 'who' })),
    ...challenge.map(c => ({ label: CHAL_LABELS[c] || c, type: 'challenge' })),
    ...(province && province !== 'all' ? [{ label: `📍 ${province}`, type: 'province' }] : []),
  ];

  return (
    <div className={styles.strip}>
      <span className={styles.icon}>✦</span>
      <div className={styles.body}>
        <div className={styles.title}>Showing programs matched to your answers</div>
        <div className={styles.tags}>
          {tags.map((t, i) => (
            <span key={i} className={`${styles.tag} ${styles[t.type]}`}>
              {t.label}
            </span>
          ))}
        </div>
      </div>
      <button className={styles.editBtn} onClick={onEdit}>
        Edit answers
      </button>
    </div>
  );
}
